<template>
    <b-standard-card
        :title="translations.title[lang]"
        :loading="loading"
        :error-message="errorMessage"
        @submit="updateThermalPrinter({ type: 'thermalPrinter', thermal_printer })"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    >
        {{ translations.info[lang] }}

        <v-row no-gutters justify="center" align="center" class="mt-3">
            <v-col cols="auto" class="subtitle-2">
                {{ translations.toggle[lang] }}:
            </v-col>
            <v-col cols="auto" class="ml-3" style="position: relative">
                <v-switch
                    v-model="thermal_printer"
                    :label="
                        thermal_printer
                            ? translations.on[lang]
                            : translations.off[lang]
                    "
                    color="secondary"
                    class="mt-0 pt-0"
                    hide-details="auto"
                ></v-switch>

            </v-col>
        </v-row>
    </b-standard-card>
</template>

<script>
import { mapActions } from "vuex";
import translations from "@/utils/translations/storePanel/settings/profile/thermalPrinter";

export default {
    name: "ThermalPrinter",

    mixins: [translations],

    data: () => ({
        thermal_printer: null
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        loading() {
            return this.$store.state.storePanel.profile.loading.thermalPrinter;
        },

        errorMessage() {
            return this.$store.state.storePanel.profile.errorMessage
                .thermalPrinter;
        },
    },

    methods: {
        ...mapActions("storePanel/profile", ["updateThermalPrinter"])
    },

    watch: {
        ["$store.state.storePanel.store.flags.reward.thermal_printer"]: {
            immediate: true,
            handler(val) {
                this.thermal_printer = val;
            }
        }
    }
};
</script>

<style scoped>
.b-not-allowed {
    cursor: no-drop;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
